import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermission } from '../context/PermissionContext';
import PageLoader from './PageLoader';
import { useAuth } from '../context/AuthContext';

interface AdminPermissionRouteProps {
  pageName: string;
  children: React.ReactNode;
}

/**
 * A route component that checks for specific page permissions
 * before allowing access to protected content
 */
const AdminPermissionRoute: React.FC<AdminPermissionRouteProps> = ({ 
  pageName, 
  children 
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { hasAdminPermission, isLoading: permissionLoading } = usePermission();
  const location = useLocation();
  if (isLoading || permissionLoading) {
    return <PageLoader />;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasAdminPermission(pageName)) {
    return <Navigate to="/access-denied" replace />;
  }
  
  return <>{children}</>;
};

export default AdminPermissionRoute;
